import './timerComponent.scss';
import CommonService from "../../services/common.service";

export interface TimerComponentProps {
    noOfSeconds: number;
}

const TimerComponent = (props: TimerComponentProps) => {

    const {noOfSeconds} = props;

    return (
        <div className="font-weight-bold">{CommonService.getMinsAndSecondsFromSeconds(noOfSeconds).minutes + " : " + CommonService.getMinsAndSecondsFromSeconds(noOfSeconds).seconds}</div>
    );

};

export default TimerComponent;
